<template>
	<div>
		<div class="user-header"></div>
		<div class="user-bg">
			<div class="user-container">
				<a href="/">
					<img src="~@/assets/img/common/logo.png" alt="" />
				</a>
				<router-view />
				<div class="links">
					<!-- <el-link type="info" :underline="false">帮助</el-link> -->
					<el-link type="info" :underline="false" href="/pages/privacy-policy" target="_blank">隐私</el-link>
					<el-link type="info" :underline="false" href="/pages/service-terms" target="_blank">条款</el-link>
					<el-link v-if="/(join-us)|(admin)/.test($route.path)===false" type="info" :underline="false" @click="replacePath('/join-us')">加入我们</el-link>
				</div>
			</div>
		</div>
		<div class="user-footer">
			<div>
				Copyright©2025 汲悟科技版权所有 | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{beian}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import Common from '@/common/mixins/common.js'
	export default {
		mixins: [Common],
		data() {
			return {
				beian: process.env.VUE_APP_BEIAN
			}
		}
	}
</script>

<style lang="scss" scoped>
	// Varbiles
	$mobile: 768px;
	$tablet: 1000px;
	.user-header, .user-footer {
		background-color: rgb(40, 57, 63);
		height: 40px;
	}
	
	.user-bg {
		min-height: calc(100vh - 80px);
		background: linear-gradient(to right bottom, rgb(130,164,141), rgb(212, 224, 142));
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 30px;
			height: 30px;
			margin-bottom: 20px;
		}
		.user-container {
			padding: 20px 30px;
			width: 400px;
			max-width: calc(100vw - 30px);
			background-color: rgba(255, 255, 255, 0.8);
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
			margin: 50px 0 170px 0;
		}
		.user-container::after {
			content: '';
			background-image: url('~@/assets/img/layouts/insurance.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: left;
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			padding-top: calc(344 / 1184 * 100%);
			transform: translateY(100%);
		}
	}
	
	.links {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		.el-link.el-link--info {
			color: #909399;
		}
	}
	.user-footer {
		display: flex;
		align-items: center;
		justify-content: center;
		& > div {
			color: lightgray;
			font-size: 12px;
			
			
			a {
				color: lightgray;
			}
			a:hover {
				text-decoration: none;
			}
		}
	}
	@media screen and (max-width: $mobile) {
		.user-footer {
			& > div {
				font-size: 10px;
			}
		}
	}
</style>